import React from 'react';
import { authorityHeadline } from '../../data/mock';

export const AuthorityHeadline = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-light text-center text-stone-800 leading-relaxed tracking-tight">
          <span className="font-semibold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
            G Developments
          </span>{' '}
          is one of Egypt's leading real estate developers.
        </h2>
      </div>
    </section>
  );
};
